import React, { useState, useEffect } from 'react';
import './SignInModal.css'; // Reusing the existing modal styles

const ForgotPasswordModal = ({ isActuallyOpen, onClose, onSwitchToSignIn }) => {
  const [email, setEmail] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (isActuallyOpen) {
      // Reset state when modal is opened
      setIsSubmitted(false);
      setEmail('');
      const timer = setTimeout(() => setIsVisible(true), 20);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isActuallyOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Password reset requested for:', email);
    setIsSubmitted(true); // Show a confirmation message
  };

  const handleOverlayClick = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  const handleCloseButtonClick = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const switchToSignIn = (e) => {
    e.preventDefault();
    setIsVisible(false);
    setTimeout(() => {
      onClose();
      if (onSwitchToSignIn) {
        onSwitchToSignIn();
      }
    }, 300);
  };

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isActuallyOpen) {
        handleCloseButtonClick();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isActuallyOpen, onClose]);

  if (!isActuallyOpen) {
    return null;
  }

  return (
    <div
      className={`modal-overlay ${isVisible ? 'open' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className="modal-content" onClick={handleModalContentClick}>
        <div className="modal-header">
          <h2>Reset Password</h2>
          <button onClick={handleCloseButtonClick} className="modal-close-button" aria-label="Close modal">
            ×
          </button>
        </div>
        
        {isSubmitted ? (
          <div className="form-confirmation">
            <p style={{ lineHeight: '1.6', fontSize: '1rem' }}>
              If an account with the email <strong>{email}</strong> exists, a password reset link has been sent. Please check your inbox.
            </p>
            <div className="form-actions" style={{ justifyContent: 'center', marginTop: '30px' }}>
               <a href="#signin" onClick={switchToSignIn} className="form-link">
                Back to Sign In
              </a>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="reset-email">Email Address</label>
              <input
                type="email"
                id="reset-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="form-actions" style={{ flexDirection: 'column', gap: '15px' }}>
              <button type="submit">Send Reset Link</button>
              <p style={{ fontSize: '0.9rem', color: 'rgba(220, 220, 220, 0.8)' }}>
                Remembered your password?{' '}
                <a href="#signin" onClick={switchToSignIn} className="form-link">
                  Sign In
                </a>
              </p>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;